module.exports = __webpack_public_path__ + "img/slide-8.0bdc3dc7.png";